import React, { useEffect, useRef, } from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,

} from '@mui/material';

import { gsap } from 'gsap';

import { useInView } from 'react-intersection-observer';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SearchIcon from '@mui/icons-material/Search';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

const HowITWorkHomeSection = () => {
    
  // const [isScrolled, setIsScrolled] = useState(false);
  const { ref: howItWorksRef, inView: howItWorksInView } = useInView({ triggerOnce: true });
  

  const howItWorksElements = useRef([]);


   useEffect(() => {
      if (howItWorksInView) {
        gsap.fromTo(
          howItWorksElements.current,
          { y: 80, opacity: 0, scale: 0.8 },
          { y: 0, opacity: 1, scale: 1, duration: 1, stagger: 0.15, ease: "back.out(1.7)" }
        );
      }
    }, [howItWorksInView]);

  return (
    <Box
        ref={howItWorksRef}
        id="how-it-works"
        sx={{
          py: { xs: 5, md: 10 },
          position: 'relative',
          // background: 'linear-gradient(180deg, #fff 0%, rgba(244, 197, 66, 0.03) 100%)'
          background:'#fff'
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ textAlign: 'center', mb: 12 }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '3rem', md: '4rem' },
                fontWeight: 900,
                mb: 4,
                color: '#2D3A27',
                letterSpacing: '-2px'
              }}
            >
              How It Works
            </Typography>
            <Typography
              variant="h5"
              sx={{
                color: 'rgba(45, 58, 39, 0.7)',
                maxWidth: '600px',
                mx: 'auto',
                fontSize: '1.4rem',
                fontWeight: 400,
                lineHeight: 1.6
              }}
            >
              Start trading scrap in just three easy steps.
            </Typography>
          </Box>

          <Grid container spacing={6} justifyContent="center">
            {[
              {
                step: '01',
                icon: <AccountCircleIcon sx={{ fontSize: 80, color: '#fff' }} />,
                title: 'Sign Up & Verify',
                description: 'Sign up and get verified',
                color: '#F4C542'
              },
              {
                step: '02',
                icon: <SearchIcon sx={{ fontSize: 80, color: '#fff' }} />,
                title: ' List or Browse',
                description: 'Post scrap or explore listings',
                color: '#4CAF50'
              },
              {
                step: '03',
                icon: <AttachMoneyIcon sx={{ fontSize: 80, color: '#fff' }} />,
                title: 'Trade Securely',
                description: 'Close deals with safe payments',
                color: '#2196F3'
              }
            ].map((step, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Card
                  ref={(el) => (howItWorksElements.current[index] = el)}
                  sx={{
                    height: '100%',
                    background: 'rgba(255, 255, 255, 0.9)',
                    backdropFilter: 'blur(20px)',
                    borderRadius: '32px',
                    border: `2px solid rgba(${
                      step.color === '#F4C542' ? '244, 197, 66' :
                      step.color === '#4CAF50' ? '76, 175, 80' :
                      '33, 150, 243'
                    }, 0.2)`,
                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                    position: 'relative',
                    overflow: 'visible',
                    '&:hover': {
                      transform: 'translateY(-20px) scale(1.03)',
                      boxShadow: `0 40px 80px rgba(${
                        step.color === '#F4C542' ? '244, 197, 66' :
                        step.color === '#4CAF50' ? '76, 175, 80' :
                        '33, 150, 243'
                      }, 0.3)`,
                      '& .step-icon': {
                        transform: 'scale(1.1) rotate(10deg)',
                      }
                    }
                  }}
                >
                  <CardContent sx={{ p: 6, textAlign: 'center' }}>
                    <Box
                      sx={{
                        position: 'absolute',
                        top: -30,
                        right: 30,
                        width: 60,
                        height: 60,
                        borderRadius: '50%',
                        background: `linear-gradient(135deg, ${step.color} 0%, ${step.color}dd 100%)`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                        fontWeight: 900,
                        fontSize: '24px',
                        boxShadow: `0 10px 30px rgba(${
                          step.color === '#F4C542' ? '244, 197, 66' :
                          step.color === '#4CAF50' ? '76, 175, 80' :
                          '33, 150, 243'
                        }, 0.5)`
                      }}
                    >
                      {step.step}
                    </Box>
                    
                    <Box
                      className="step-icon"
                      sx={{
                        width: 120,
                        height: 120,
                        borderRadius: '24px',
                        background: `linear-gradient(135deg, ${step.color} 0%, ${step.color}dd 100%)`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mx: 'auto',
                        mb: 4,
                        transition: 'all 0.3s ease',
                        boxShadow: `0 20px 40px rgba(${
                          step.color === '#F4C542' ? '244, 197, 66' :
                          step.color === '#4CAF50' ? '76, 175, 80' :
                          '33, 150, 243'
                        }, 0.3)`
                      }}
                    >
                      {step.icon}
                    </Box>
                    
                    <Typography
                      variant="h4"
                      sx={{
                        color: '#2D3A27',
                        fontWeight: 700,
                        mb: 3,
                        fontSize: '1.8rem'
                      }}
                    >
                      {step.title}
                    </Typography>
                    
                    <Typography
                      variant="body1"
                      sx={{
                        color: 'rgba(45, 58, 39, 0.7)',
                        lineHeight: 1.7,
                        fontSize: '1.1rem'
                      }}
                    >
                      {step.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
    </Box>
  );
};

export default HowITWorkHomeSection;
